import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cls } from '@/utils/cls';

function Slider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  const _values = React.useMemo(
    () =>
      Array.isArray(value)
        ? value
        : Array.isArray(defaultValue)
          ? defaultValue
          : [min, max],
    [value, defaultValue, min, max],
  );

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cls(
        'relative flex w-full touch-none select-none items-center data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col data-[disabled]:opacity-50',
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className={cls(
          'relative grow overflow-hidden rounded-full bg-zinc-100 data-[orientation=horizontal]:h-1.5 data-[orientation=vertical]:h-full data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-1.5 dark:bg-zinc-800',
        )}
      >
        <SliderPrimitive.Range
          data-slot="slider-range"
          className={cls(
            'absolute bg-primary-500 data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full dark:bg-zinc-50',
          )}
        />
      </SliderPrimitive.Track>
      {Array.from({ length: _values.length }, (_, index) => (
        <SliderPrimitive.Thumb
          data-slot="slider-thumb"
          key={index}
          className="focus-visible:outline-hidden ring-primary-950/50 dark:ring-primary-300/50 block size-4 shrink-0 rounded-full border border-zinc-200 bg-white shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 disabled:pointer-events-none disabled:opacity-50 dark:border-primary-50 dark:bg-primary-950"
        />
      ))}
    </SliderPrimitive.Root>
  );
}

export { Slider };
